import type { Moment } from 'moment';
import type { ReactNode } from 'react';

/** Option for filter options list or operator list (custom_options / queryOptions). Compatible with IDropdownOption. */
export interface FilterOption {
  value: string | number;
  label?: string;
  text?: string;
  key?: string | number;
  content?: ReactNode;
  name?: string;
  flag?: string;
  item?: unknown;
}

/** Operator option for typeQuery selector */
export type OperatorOption = FilterOption & {
  conditionImage?: ReactNode;
};

type ItemType = {
  [key: string]: any;
};

/** Single filter configuration in the filters array */
export type FilterConfig = {
  name: string;
  label: string;
  icon: ReactNode;
  options?: FilterOption[];
  typeQuery?: string;
  defaultValue?: string | string[] | number | unknown;
  defaultQuery?: string;
  multiple?: boolean;
  search?: boolean;
  sorted?: boolean;
  /** 'date' for date picker */
  type?: string;
  /** Moment format for date values (default: DD-MM-YYYY) */
  dateFormat?: string;
  /** Disable dates in the date picker (Ant Design disabledDate) */
  disabledDate?: (current: Moment) => boolean;
  /** Operator list (Equals, Not Equals, etc.); alias: queryOptions */
  customOptions?: OperatorOption[];
  queryOptions?: OperatorOption[];
  /** Async search for options (e.g. Created By) */
  customSearch?: (item: ItemType, query: string) => boolean;
  /** Hide from filter list (e.g. status, page, limit) */
  skip?: boolean;
};

/** Filter state: flat object of filter name and typeQuery keys to string values */
export type FilterState = Record<string, string>;

export const DEFAULT_OPERATOR_OPTIONS: OperatorOption[] = [
  { value: 'EQUAL', key: 'EQUAL', text: 'Equals', label: 'Equals' },
  {
    value: 'NOT_EQUAL',
    key: 'NOT_EQUAL',
    text: 'Does Not Equal',
    label: 'Does Not Equal',
  },
];
